'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _MessagesEventSchema = require('conversations-core/hublytics/MessagesEventSchema');

var _MessagesEventSchema2 = _interopRequireDefault(_MessagesEventSchema);

var _createLogAction = require('event-tracking-tools/redux/createLogAction');

var _createLogAction2 = _interopRequireDefault(_createLogAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_LOCATION_TIMEOUT = 200; // ms

exports.default = function (store) {
  function handleLocationChange(action) {
    /* eslint-disable camelcase */
    var _action$payload = action.payload,
        in_onboarding = _action$payload.in_onboarding,
        url = _action$payload.url,
        _action$payload$event = _action$payload.eventName,
        eventName = _action$payload$event === undefined ? 'changeWindowLocation' : _action$payload$event;
    /* eslint-enable camelcase */

    var urlWithoutPortalId = url.replace(_hubspot2.default.get(), '*');

    /* eslint-disable camelcase */
    store.dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get(eventName), {
      page_url: urlWithoutPortalId,
      in_onboarding: in_onboarding
    }));
    /* eslint-enable camelcase */

    setTimeout(function () {
      window.location = url;
    }, CHANGE_LOCATION_TIMEOUT);
  }

  return function (next) {
    return function (action) {
      switch (action.type) {
        case _ActionTypes2.default.CHANGE_WINDOW_LOCATION:
          handleLocationChange(action);
          break;

        default:
          break;
      }
      return next(action);
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/WindowMiddleware.js
// module id = 490
// module chunks = 0